import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal, SxProps, Theme } from "@mui/material";
import MainButton from "new-components/buttons/main-button";
import { ReactNode } from "react";

interface ConfirmModalProps {
    isOpen: boolean
    handleClose: () => void
    children: ReactNode
    size: 'XS' | 'S' | 'M' | 'L'
    title: string
    btnLeft?: { onClick: () => void, title: string, type?: 'primary' | 'secondary' | 'danger', variant?: 'contained' | 'outlined', sx?: SxProps }
    onSubmit: { onClick: () => void, title?: string, type?: "primary" | 'danger', disabled?: boolean, width?: number, startIcon?: ReactNode }
    onCancel: { onClick: () => void, title?: string, disabled?: boolean }
    onCloseCancel?: boolean
    onCloseSubmit?: boolean
    overflow?: boolean
    sx?: SxProps<Theme>;
    childrenTopLeft?: ReactNode
}

export default function PageModal(props: ConfirmModalProps) {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: props.size === 'XS' ? 500 : props.size === 'S' ? 800 : props.size === 'M' ? 1140 : 1600,
        bgcolor: '#F7F7F7',
        borderRadius: '10px',
        boxShadow: 24,
        minWidth: 300,
        maxWidth: '95vw',
        maxHeight: '90vh',
        paddingX: '24px',
        overflow: props.overflow ? 'auto' : '',
        paddingY: '24px'
    };

    return (
        // zIndex: 2000
        <Modal open={props.isOpen} onClose={props.handleClose} sx={{ overflow: 'auto', ...(props.sx as Record<string, unknown>) }}>
            <>
                <Box sx={style}>
                    <Box display="flex" alignItems="center">
                        <Box sx={{ flex: 1 }}>{props.childrenTopLeft}</Box>

                        <Box
                            sx={{
                                textAlign: "center",
                                color: "#2F4269",
                                fontSize: "20px",
                                fontWeight: 600,
                                flex: 1,
                            }}
                        >
                            {props.title}
                        </Box>

                        <Box sx={{ flex: 1, textAlign: "right" }}>
                            <IconButton onClick={props.onCancel?.onClick}>
                                <CloseIcon sx={{ width: "24px", height: "24px", color: "#808080" }} />
                            </IconButton>
                        </Box>
                    </Box>
                    {props.children}
                    <Box sx={{ display: 'flex', justifyContent: props.btnLeft?.title ? 'space-between' : "end", alignItems: 'center', marginTop: '24px' }}>
                        {props.btnLeft?.title && <MainButton onClick={props.btnLeft?.onClick} title={props.btnLeft?.title || ''} type={props.btnLeft?.type || 'primary'} variant={props.btnLeft?.variant || 'outlined'} style={{ width: 120, ...props.btnLeft?.sx }} />}
                        <Box sx={{ display: 'flex', gap: '16px' }}>
                            {!props.onCloseCancel && <MainButton onClick={props.onCancel?.onClick} title={props.onCancel?.title || 'ยกเลิก'} type="secondary" variant="outlined" style={{ width: 120 }} disabled={props.onCancel?.disabled} />}
                            {!props.onCloseSubmit && <MainButton onClick={props.onSubmit?.onClick} title={props.onSubmit?.title || 'บันทึก'} type={props.onSubmit.type || 'primary'} variant="contained" style={{ width: props.onSubmit.width || 120 }} disabled={props.onSubmit?.disabled} startIcon={props.onSubmit?.startIcon} />}
                        </Box>
                    </Box>
                </Box>
            </>

        </Modal>
    )
}